import { render } from "./user_profile_modal.html?vue&type=template&id=d6b997aa&external"
import script from "./user_profile_modal.js?vue&type=script&lang=js&external"
export * from "./user_profile_modal.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__